import { END_POINT } from "../constants";
import { HTTP } from "./http";

export const EmailTemplateService = {

  save: (data: any) => {
    return HTTP.post<any, any>(`${END_POINT}email-templates`, data);
  },
  getAll: () => {
    return HTTP.get<any, any>(`${END_POINT}email-templates`);
  },
  delete: (id: string) => {
    return HTTP.delete<any, any>(`${END_POINT}email-templates/${id}`);
  },
  update: (data: any) => {
    return HTTP.put<any, any>(`${END_POINT}email-templates`, data);
  },
  uploadMedia: (data: any) => {
    return HTTP.post<any, any>(`${END_POINT}email-templates/assets/upload`, data);
  },
}